import React, { useCallback } from 'react';
import { prepareProps } from '../../../utils/propUtils';
import { PropsWithoutChildren } from '../../../utils/utilityTypes';
import { classes } from '../../../utils/utils';
import styles from './BaseDialogTabTitle.module.css';

export type BaseDialogTabTitleProps<TTabName extends string> =
  PropsWithoutChildren<{
    name: TTabName;
    title: string;
    selected: boolean;
    onSelected?: (name: TTabName) => void;
  }>;

export const BaseDialogTabTitle = React.memo(
  <TTabName extends string>(props: BaseDialogTabTitleProps<TTabName>) => {
    const { name, selected, title, onSelected } = prepareProps({
      props,
      ignoreChildren: true
    });

    const handleClick = useCallback(() => {
      if (!selected) {
        onSelected?.(name);
      }
    }, [name, selected, onSelected]);

    return (
      <button
        type="button"
        className={classes(
          styles.tabTitle,
          selected ? styles.selectedTabTitle : null
        )}
        onClick={handleClick}
      >
        <div
          className={styles.tabTitleText}
          data-testid="BaseDialogTabTitle.TitleText"
        >
          {title}
        </div>
      </button>
    );
  }
) as <TTabName extends string>(
  props: BaseDialogTabTitleProps<TTabName>
) => JSX.Element;
